module.exports = __webpack_public_path__ + "static/media/register.226ef1a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/OpenChallenges/register.svg
// module id = 180
// module chunks = 0